import axios from "axios";
import exampleSNPs from "@/data/exampleSNPs.js";

interface SnpResp {
   id: string;
   source: string;
   value: string;
   rsid: object;
   forwardStrand: boolean | null;
   fromReference: boolean;
}

export default class SnpApi {
   public static readMySnps = async (rsids: string[], all_rsids = false): Promise<SnpResp[]> => {
      // Fetch SNPs from the database (or use an example set for local development
      // [not for testing - we use intercept there to be able to test e.g. both with & without data])
      let response = null;
      const isLocalDevAndNotE2e = import.meta.env.MODE === "development" && !(window as any).Cypress;

      if (isLocalDevAndNotE2e) {
         console.info("Using example SNPs");
         let requiredSnps = exampleSNPs;
         if (!all_rsids && rsids) requiredSnps = exampleSNPs.filter((obj) => rsids.includes(obj.rsid));

         response = requiredSnps;
      } else {
         /**
          * This was originally written to work with PiniaORM, and has been copied directly.
          * Could potentially be refactored if used in ernest in the future
          */
         const res = await axios.put("/snps", { data: { rsids, all_rsids } });
         response = res.data;
      }

      return response;
   };
}
